import Text from 'components/elements/Text'

// 페이지 - 리스트 뷰 컴포넌트
function NextPrevContent({ next, prev }) {
  return (
    <ul className="pager">
      {prev && (
        <li className="prev" onClick={prev?.clickPrev}>
          <div className="pager-left">
            <Text text="이전" />
          </div>
          <div className="pager-right">
            <Text text={prev.title} />
          </div>
        </li>
      )}
      {next && (
        <li className="next">
          <div className="pager-left" onClick={prev?.clickNext}>
            <Text text="다음" />
          </div>
          <div className="pager-right">
            <Text text={next.title} />
          </div>
        </li>
      )}
    </ul>
  )
}

export default NextPrevContent
